exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Nav-Link{color:#ccc}.link-active{color:#1d1d1d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/NavLink/NavLink.scss
// module id = 327
// module chunks = 0